<sb-dialog-header>
  <h3 sb-dialog-title>
    {{
      data?.category === TemplateCategory.EXTENSION
        ? ('Create contract extension' | translate)
        : ('Create employment contract' | translate)
    }}
  </h3>
</sb-dialog-header>

<sb-dialog-content>
  <sb-dialog-sidebar>
    <div>
      <h3>{{ 'Fields list' | translate }}</h3>
      <button sb-button [color]="'secondary'" (click)="createNewField()">
        {{ 'Create new field' | translate }}
      </button>
    </div>
    <sb-search-input
      [(ngModel)]="searchQuery"
      (ngModelChange)="onSearch()"
      [ngModelOptions]="{ standalone: true }"
    ></sb-search-input>
    <div>
      <sb-card>
        <sb-card-header>
          <sb-card-title>
            {{ 'E-Sign fields' | translate }}
          </sb-card-title>
        </sb-card-header>
        <sb-card-content>
          <p [innerHTML]="'Add <b>all required fields</b> below to your contract to use e-sign.' | translate"></p>
          <ul>
            @for (field of eSignFields; track field.variable) {
              <li>
                <sb-field-button [field]="field"></sb-field-button>
              </li>
            }
            @for (field of guardianESignFields(); track field.variable) {
              <li>
                <sb-field-button [field]="field"></sb-field-button>
              </li>
            }
          </ul>
        </sb-card-content>
      </sb-card>
      <ul>
        @if (guardianNameFields().length > 0) {
          <li>
            <h4>
              {{ 'Guardian' | translate }}
              @if (guardianFieldsRequired()) {
                <span class="ml-1 text-xs font-semibold text-brand">
                  {{ 'Required for guardian signing' | translate }}
                </span>
              }
            </h4>
            <ul>
              @for (field of guardianNameFields(); track field.variable) {
                <li>
                  <sb-field-button [field]="field"></sb-field-button>
                </li>
              }
            </ul>
          </li>
        }
        @for (group of groupedSystemVariables; track group.label) {
          <li>
            @if (group.label) {
              <h4>{{ group.label }}</h4>
            }
            <ul>
              @for (field of group.fields; track field.variable) {
                <li>
                  <sb-field-button [field]="field"></sb-field-button>
                  @if (field.custom) {
                    <button
                      sb-icon-button
                      [color]="'transparent'"
                      [size]="'sm'"
                      [attr.aria-label]="'Edit [field]' | translate: { field: field.label }"
                      (click)="editField(field)"
                    >
                      <sb-icon [name]="'pen-2-regular'" class="text-subtle" />
                    </button>
                  }
                </li>
              }
            </ul>
          </li>
        }
      </ul>
    </div>
  </sb-dialog-sidebar>
  <section>
    <ol>
      <li>
        <div>
          <span>1</span>
          <h4>{{ 'Pick your fields' | translate }}</h4>
        </div>
        <p>
          {{ 'Choose the details you want to fill in automatically — like name, start date, or salary.' | translate }}
        </p>
      </li>
      <li>
        <div>
          <span>2</span>
          <h4>{{ 'Insert in Document' | translate }}</h4>
        </div>
        <p>
          {{ "Use placeholders like {first_name} in your contract — we'll fill in the rest." | translate }}
        </p>
      </li>
      <li>
        <div>
          <span>3</span>
          <h4>{{ 'Save your template' | translate }}</h4>
        </div>
        <p>
          {{ "Upload your .docx file — we'll detect the fields and turn it into a reusable contract." | translate }}
        </p>
      </li>
    </ol>
    <p>
      {{ 'Need help?' | translate }}
      <a [href]="exampleDocumentUrl">{{ 'Download our example document' | translate }}</a>
      {{ 'to see how the fields work.' | translate }}
    </p>

    @if (features.TMP_GUARDIAN_SIGNATURE | featureFlag) {
      @if (features.TMP_GUARDIAN_SIGNATURE_COUNT | featureFlag) {
        <sb-form-field [label]="'Number of guardians' | translate">
          <sb-select [items]="guardianSignatureCountItems" [formControl]="guardianSignatureCount"></sb-select>
        </sb-form-field>
      } @else {
        <sb-checkbox [formControl]="requiresGuardianSignature" [truncateLabel]="false">
          {{ 'Requires guardian signature' | translate }}
        </sb-checkbox>
      }
    }

    @if (guardianFieldsRequired()) {
      <sb-notice [variant]="'info'">
        <p class="reset-p">
          {{
            "Also add the guardian fields shown on the left to your document. E-sign uses them to place the guardian's signature."
              | translate
          }}
        </p>
      </sb-notice>
    }

    <sb-upload
      [allowedTypes]="['.docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']"
      [multiple]="false"
      [isUploading]="uploading"
      (uploadResult)="handleFileInput($event)"
    >
      {{ 'Upload a Word document (.docx only)' | translate }}
    </sb-upload>
  </section>
</sb-dialog-content>
<sb-dialog-footer>
  <sb-dialog-footer-actions [align]="'end'">
    <button sb-button [disabled]="true">
      {{ 'Replace document' | translate }}
    </button>
    <button sb-button [disabled]="true" [color]="'primary'">
      {{ 'Finish' | translate }}
    </button>
  </sb-dialog-footer-actions>
</sb-dialog-footer>
